module.exports = __webpack_public_path__ + "assets/delete.0cff0ffb.svg";